export const MAINTENANCE_ROUTES = {
  list: '/settings/maintenances',
  edit: '/settings/maintenance',
  historyList: '/settings/maintenance/history',
  historyNew: '/settings/maintenance/history/new',
};

export const MAINTENANCE_ENDPOINTS = {
  traccarMaintenance: '/api/maintenance',
  maintenanceHistory: '/maintenance-api/maintenance-records',
  devices: '/api/devices',
  permissions: '/api/permissions',
};

export const isMaintenanceHistoryPath = (path) =>
  path.startsWith(MAINTENANCE_ROUTES.historyList);
